import { call, put, takeLatest } from 'redux-saga/effects'
import {
  getListSectorsSuccess,
  getListSectorsFailed,
  GET_LIST_SECTORS_START,
} from '../../actions/sector'
import { api } from '~/services/api/gameApi'

/**
 * get list sector pools api
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const getListSectorsApi = (props) => {
  var uri = `/api/game/sector/get`
  return api.post(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doGetListSectors(action) {
  try {
    const response = yield call(getListSectorsApi, action?.payload)
    yield put(getListSectorsSuccess(response))
    // Call callback action if provided
    if (action.onSuccess) {
      yield action.onSuccess(response)
    }
  } catch (error) {
    yield put(getListSectorsFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch get list sector pools
 */
export default function* watchGetListSector() {
  yield takeLatest(GET_LIST_SECTORS_START, doGetListSectors)
}
